export default __webpack_public_path__ + "static/media/cscw2023-slides.37097e85.pdf";